<div class="row">
    <div class="col-md-6">
        <app-closed-date-basic-info [closedDate]="closeddate" [canEdit]="canEdit"></app-closed-date-basic-info>
    </div>
</div>
